import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { AdvisorCompany } from '../models/advisor-company.model';

export const LoadAdvisorCompanies = createAsyncThunk(
    'advisorCompanies/load',
    async (_, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        const response = await axios.get('api/marketplace/advisor-companies');

        if (response.status !== 200) {
            createNotification(
                'An error occurred while loading advisor companies.',
                'error'
            );
            throw new Error('Failed to load advisor companies');
        }

        return response.data as AdvisorCompany[];
    }
);
